import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ibanValidator } from './iban/iban-validator';
import { IBANCulture } from './iban/iban-culture';
import { IbanFormatDirective } from './iban/iban-format.directive';
import { IBANDetail } from '../models/iban-detail-model';
import {
  HsFormFieldModule,
  HsIconModule,
  HsInputModule,
} from '@hsetu/ngui-components';
import { IBAN_LABEL } from '@modules/contact/i18n/label-text-constants';

@Component({
  selector: 'kfm-iban-input-field',
  imports: [
    CommonModule,
    FormsModule,
    HsInputModule,
    HsIconModule,
    HsFormFieldModule,
    ReactiveFormsModule,
    IbanFormatDirective,
  ],
  templateUrl: './kfm-iban-input-field.component.html',
})
export class KfmIbanInputFieldComponent {
  @ViewChild('ibanInput') private ibanInput!: ElementRef<HTMLInputElement>;

  private _ibanDetail: IBANDetail = new IBANDetail(IBANCulture.DE, '');

  protected readonly ibanLabel = IBAN_LABEL;

  @Input() set ibanDetail(val: IBANDetail) {
    this._ibanDetail = val;
    this.ibanControl.setValue(val?.iban || '');
  }

  public get ibanDetail(): IBANDetail {
    return this._ibanDetail;
  }

  public focusInput(): void {
    this.ibanInput?.nativeElement.focus();
  }

  public IBANCulture = IBANCulture;
  public ibanControl = new FormControl('', [
    Validators.required,
    ibanValidator,
  ]);
}
